import {Stack} from "@mui/material";
import TmbLogoLabel from "./tmbLogoLabel";
import StarSign from "../brand/starSign";
import Personality from "../brand/personality";
import LoveHeart from "../brand/loveHeart";
import React from "react";

interface Icon {
    colour?: string;
    size?: number;
}

interface Props {
    starIcon?: Icon,
    eclipseIcon?: Icon,
    heartIcon?: Icon,
    textColour?: string,
    textWidth?: number,
    textHeight?: number,
}

const TmbLogo = (props: Props) => {

    const {
        starIcon,
        eclipseIcon,
        heartIcon,
        textColour,
        textWidth,
        textHeight
    } = props;
    
    return <Stack alignItems={"center"}>
        <TmbLogoLabel width={textWidth ?? 120} height={textHeight ?? 12} fill={textColour} />
        <Stack flexDirection={"row"} gap={0.5} >
            <StarSign size={starIcon?.size ?? 16} fill={starIcon?.colour} />
            <Personality size={eclipseIcon?.size ?? 16} fill={eclipseIcon?.colour} />
            <LoveHeart size={heartIcon?.size ?? 16} fill={heartIcon?.colour} />
        </Stack>
    </Stack>
};

export default TmbLogo;